import React from "react";
import SidebarThemeSettings from "../components/SidebarThemeSettings";
import "../assets/css/Settings.css";

function Settings() {
  return (
    <div className="settings-page">
      <div className="settings-card">
        <h1 className="settings-page__title">Settings</h1>
        <SidebarThemeSettings scope="office" />
      </div>
    </div>
  );
}

export default Settings;
